import { Component, OnInit } from '@angular/core';
import { BaseModalDirective } from '@app/components/modals/base-modal';

@Component({
    templateUrl: './assisting-person-types.component.html',
    standalone: false
})
export class AssistingPersonTypesModalComponent extends BaseModalDirective implements OnInit {
    globalLang: string;

    ngOnInit(): void {
        this.globalLang = sessionStorage.getItem('globalTranslatedLan');
    }
}
